import { Printer } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { usePrinter } from "@/context/PrinterContext";

/** Prints the batch's scaled ingredient list + allergens + recipe notes on the BT label printer. */
export default function PrintRecipeButton({ recipe, batch, nameFor, requiredFor }) {
  const printer = usePrinter();
  const print = async () => {
    if (!printer?.isConnected) {
      toast.error("Connect the Bluetooth label printer first (printer chip at the top)");
      return;
    }
    const ok = await printer.printRecipeLabel({
      name: recipe?.name,
      batch_code: batch.batch_code,
      planned: batch.quantity_planned,
      yield_unit: recipe?.yield_unit,
      ingredients: (recipe?.ingredients || []).map((i) => ({ name: nameFor(i), qty: requiredFor(i), unit: i.unit })),
      allergens: recipe?.allergens || [],
      notes: recipe?.instructions || "",
    });
    if (ok) toast.success("Recipe sent to printer");
  };
  return (
    <Button variant="outline" className="h-9 gap-1.5" onClick={print} disabled={!recipe} data-testid="print-recipe-button">
      <Printer className="h-4 w-4" /> Print recipe
    </Button>
  );
}
